export { default } from './Boleto25Video';
